import React from "react";
import AlvnaBrand from "../components/AlvnaBrand";
import ClockForm from "../components/ClockForm";
import { colors, fonts, space, radius } from "../theme";

// Public clock-in page (no login), reached from the QR code or link a restaurant posts by the door or till.
// The actual form (name/PIN, camera, GPS, and which button to show) lives in ClockForm so the Waiter/Kitchen
// in-page window uses the exact same logic.
export default function ClockPage() {
  const tenant = new URLSearchParams(window.location.search).get("tenant") || "";
  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <AlvnaBrand variant="full" />
        <div style={{ padding: space[5], paddingTop: 0 }}>
          <h2 style={styles.heading}>Clock In / Out</h2>
          <ClockForm tenant={tenant} />
        </div>
      </div>
    </div>
  );
}

const styles = {
  page: { minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: colors.bgPage, padding: space[4], boxSizing: "border-box" },
  card: { width: "100%", maxWidth: 420, background: colors.surface, borderRadius: radius.lg, boxShadow: "0 1px 3px rgba(0,0,0,0.08)", overflow: "hidden" },
  heading: { margin: `0 0 ${space[3]}`, fontFamily: fonts.display, fontSize: 19, fontWeight: 600, textAlign: "center", color: colors.textPrimary },
};
